<template>
  <v-container>
    <v-layout row wrap>
      <template v-if="isLoading">
        <v-flex xs12 text-xs-center>
          <h1>Checking Subscriptions...</h1>
        </v-flex>
        <v-flex xs12 text-xs-center>
          <v-progress-circular
            size="75"
            width="5"
            color="accent"
            class="ma-5"
            indeterminate
          />
        </v-flex>
      </template>
      <template v-else>
        <v-flex xs12>
          <h1>Subscribe</h1>
          <p v-if="!isSubscribed">The page you requested requires an active subscription to view.</p>
          <p v-else>You already have an active subscription, but you can extend it here.</p>
          <v-btn
            @click="subscribe"
            :loading="subscribeLoading"
            :disabled="subscribeLoading"
          >
            Subscribe
          </v-btn>
        </v-flex>
      </template>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  data: () => ({
    isLoading: false,
    subscribeLoading: false,
    isSubscribed: false
  }),
  mounted: async function () {
    // Mark activity before starting anything else
    this.isLoading = true

    // Get any subscriptions for the user, sorted with the latest end date first
    let subscriptions = (await this.$auth.subscriptions()).sort((a, b) => {
      if (a.endDate > b.endDate) {
        return -1
      }
      if (b.endDate > a.endDate) {
        return 1
      }
      return 0
    })

    // If we have no action to take, we don't need to do anything unless the
    // user has an unapproved PayPal subscription that they're revisiting, in
    // which case we want to redirect to the approval URL
    if (this.$route.params.action === undefined) {
      for (let i in subscriptions) {
        if (subscriptions[i].ppApprovalURL !== null &&
            subscriptions[i].approvalDate === null &&
            (subscriptions[i].terminalDate === null || subscriptions[i].terminalDate > (new Date())) &&
            subscriptions[i].cancelDate === null) {
          // Before blindly redirecting, test the approval status of our target
          // subscription to avoid redirecting the user to PayPal in situations
          // where that isn't actually required.
          let status = await (
            this.axios.post('/subscriptions/billing/paypal/approval/' + subscriptions[i].ppSubscriptionID)
              .then((res) => {
                return res.status
              })
              .catch((err) => {
                return err.response.status
              })
          )
          if (status === 404) {
            await (this.axios.delete('/subscriptions/' + subscriptions[i].id).catch(() => {}))
            subscriptions[i].cancelDate = new Date()
          } else if (status === 201) {
            return this.$router.push('/')
          } else {
            window.location.href = subscriptions[i].ppApprovalURL
            return
          }
        }
      }
    } else {
      // Valid actions are 'approve' or 'cancel', and they're relevant only if
      // we're returning from a PayPal subscription process. So, we want to make
      // sure that we've actually come from PayPal.
      if (this.$route.query.subscription_id === undefined) {
        return this.$router.push('/')
      }

      // Identify which subscription matches our PayPal subscription ID
      let sub = subscriptions.find((sub) => {
        return sub.ppSubscriptionID === this.$route.query.subscription_id
      })

      // If we didn't find a match, then something went wrong and we don't want to continue
      if (sub === undefined) {
        return this.$router.push('/')
      }

      // Now that we have a match, see what we need to do with it
      switch (this.$route.params.action) {
        case 'approve':
          return this.axios.post('/subscriptions/billing/paypal/approval/' + this.$route.query.subscription_id)
            .then(() => {
              // XXX: Return the user back to where they were trying to go before
              // they were sent to the subscription page?
              return this.$router.push('/')
            })
            .catch(this.$root.apiErrorHandler(() => {
              this.isLoading = false
              return true // show our standard error message
            }))
        case 'cancel':
          return this.axios.delete('/subscriptions/' + sub.id)
            .then(() => {
              return this.$router.push('/')
            })
            .catch(this.$root.apiErrorHandler(() => {
              this.isLoading = false
              return true // show our standard error message
            }))
      }
    }

    // Update our subscription status
    this.isSubscribed = await this.$auth.isSubscribed()
    this.isLoading = false
  },
  methods: {
    subscribe: function () {
      this.subscribeLoading = true

      let userID = this.$auth.user().id
      this.axios.post('/subscriptions/user/' + userID)
        .then((res) => {
          // Get our subscription ID from the Location header
          let subID = res.headers.location

          // Retrieve details on our subscription so we can direct to PayPal if necessary
          this.axios.get('/subscriptions/' + subID)
            .then((res) => {
              let sub = res.data[0]
              if (sub.ppApprovalURL !== null) {
                window.location.href = sub.ppApprovalURL
              } else {
                // XXX: Return the user back to where they were trying to go before
                // they were sent to the subscription page?
                return this.$router.push('/')
              }
            })
            .catch(this.$root.apiErrorHandler())
        })
        .catch(this.$root.apiErrorHandler(() => {
          this.subscribeLoading = false
          return true // show our standard error message
        }))
    }
  }
}
</script>
